import { __exports as e } from "../../../../../../_virtual/react-compiler-runtime.production.js";
import o from "react";
var r;
function n() {
  if (r) return e;
  r = 1;
  var t = o.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  return e.c = function(_) {
    return t.H.useMemoCache(_);
  }, e;
}
export {
  n as __require
};
